{
  "fr": {
    "errors": {
      "audioNotSupported": "Format audio non pris en charge",
      "audioRecordingDeviceError": "Erreur du périphérique d’enregistrement audio",
      "connectionAuthenticationFailed": "Connexion refusée par le serveur. Échec de l’authentification.",
      "connectionRejected": "La connexion au serveur a été refusée",
      "createFromTemplateFailed": "Erreur lors de la création à partir du modèle",
      "createItemFailed": "Erreur lors de la création du contenu",
      "deleted": {
        "header": "Ce contenu a été supprimé",
        "link": "Accéder aux outils IA",
        "paragraph": "La personne qui a partagé ce contenu l'a supprimé. Il ne peut donc plus être affiché."
      },
      "downloadFailed": "Le fichier n'a pas pu être téléchargé. Veuillez recharger la page et réessayer.",
      "error": "Erreur",
      "fileAlreadyExists": "Le fichier « {filename} » existe déjà",
      "fileUploadFailed": "Erreur lors du téléversement du fichier",
      "forbidden": {
        "header": "Malheureusement, vous n’avez pas accès à ces contenus",
        "link": "Aller aux outils fobizz",
        "paragraph": "Vous avez besoin d’une invitation par lien de partage pour voir ces contenus. Contactez la personne qui vous a envoyé le lien et demandez-lui de vous envoyer le bon lien."
      },
      "generic": {
        "header": "Un problème est survenu !",
        "link": "Aller aux outils fobizz",
        "paragraph": "Une erreur s’est produite. Merci de réessayer plus tard !"
      },
      "h5pContentNotFound": "Contenu H5P introuvable",
      "h5pUploadFailed": "Erreur lors du téléversement du fichier H5P",
      "liveConnectionLost": {
        "description": "Cette page ne se met plus à jour automatiquement. Recharge-la pour recevoir à nouveau les mises à jour en direct.",
        "reload": "Recharger la page",
        "title": "Aucune connexion en direct"
      },
      "toTeachImportFailed": "Erreur lors de l’importation de l’exercice to teach",
      "toTeachNoH5pDownload": "Cet exercice ne contient aucun téléchargement H5P",
      "imageUploadFailed": "Erreur lors du téléversement de l’image",
      "internalError": "Une erreur interne s’est produite",
      "invalidUrl": "Cette URL n’est pas correcte.",
      "jobProcessingFailed": "Erreur lors du traitement de ta demande",
      "jobProcessingFailedWithDetails": "Erreur lors du traitement de ta demande : {message}",
      "jobTimeout": "Le traitement prend anormalement longtemps et a été interrompu. Veuillez réessayer.",
      "noAudioInputDeviceFound": "Aucun périphérique d’entrée audio trouvé",
      "noVideoInputDeviceFound": "Aucun périphérique d’entrée vidéo trouvé",
      "notFound": {
        "header": "Cela n’a malheureusement pas fonctionné !",
        "link": "Aller aux outils fobizz",
        "paragraph": "L’adresse que tu cherches n’existe pas – ou plus !"
      },
      "partnerNotEnabled": "Malheureusement, nos partenaires ont été désactivés pour toi.",
      "previewImageGenerationFailed": "La génération d'image a échoué. Veuillez réessayer.",
      "previewImageGenerationTimeout": "La génération d'image prend un temps inhabituellement long et a été annulée. Veuillez réessayer.",
      "remixFailed": "Erreur lors du remix du contenu",
      "somethingWentWrong": "Quelque chose s'est mal passé",
      "unauthorized": {
        "header": "Cela n’a malheureusement pas fonctionné !",
        "link": "Aller aux outils fobizz",
        "paragraph": "Merci de te connecter pour accéder à cette page !"
      },
      "unknownAudioRecordingError": "Erreur d’enregistrement audio inconnue",
      "unknownErrorRefresh": "Erreur inconnue. La page va être rechargée !",
      "unknownVideoRecordingError": "Erreur d’enregistrement vidéo inconnue",
      "uploadFileTooLarge": "Le fichier ne peut pas être téléversé, car il est plus grand que {maxSize} Mo",
      "uploadTotalSizeExceeded": "Le fichier ne peut pas être téléversé, car la taille totale de {maxTotalSize} Mo est dépassée",
      "uploadFileTooSmall": "Le fichier ne peut pas être téléversé, car il a une taille de 0 Mo.",
      "validationError": "Erreur de validation",
      "videoRecordingDeviceError": "Erreur du périphérique d’enregistrement vidéo"
    }
  }
}
